import type { Firebase } from '@linktivity/link-utils';

let firebase: Promise<Firebase> | undefined;

// Loaded on first use: signing out is the only thing this app does with
// Firebase so far, and the SDK is too large to put on every page for it.
// Cached because Firebase allows one default app per page.
function getFirebase(): Promise<Firebase> {
  firebase ??= import('@linktivity/link-utils').then(({ Firebase }) => {
    const tenantId = import.meta.env.VITE_APP_FIREBASE_TENANT_ID;
    const instance = new Firebase({
      apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN
    });
    instance.setTenantId(tenantId);
    return instance;
  });
  return firebase;
}

/**
 * End the Firebase sign-in the SPA's login page started, so the next login
 * starts fresh. The ARS tokens are the session itself; see revokeTokens().
 */
export async function signOutFirebase() {
  await (await getFirebase()).logout();
}
